import { cn } from "@/lib/utils";

// Animated "aurora" mesh background: slowly drifting gradient blobs plus a
// subtle grid. Purely decorative and pointer-events-none so it never blocks UI.
export default function AuroraBackground({
  className,
}: {
  className?: string;
}) {
  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none absolute inset-0 -z-10 overflow-hidden",
        className,
      )}
    >
      <div className="enkey-aurora enkey-aurora-primary absolute -left-1/4 top-[-20%] h-[60vw] w-[60vw] rounded-full bg-primary/40 blur-[110px] dark:bg-primary/30" />
      <div className="enkey-aurora enkey-aurora-accent absolute right-[-15%] top-[10%] h-[50vw] w-[50vw] rounded-full bg-accent/40 blur-[110px] dark:bg-accent/30" />
      <div className="enkey-aurora enkey-aurora-chart absolute bottom-[-25%] left-[20%] h-[55vw] w-[55vw] rounded-full bg-chart-3/35 blur-[120px] dark:bg-chart-3/25" />
      {/* Fine grid overlay for a technical feel */}
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)",
          backgroundSize: "48px 48px",
          maskImage:
            "radial-gradient(ellipse at center, black 40%, transparent 80%)",
        }}
      />
    </div>
  );
}
